import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  width: 100vw;
  min-height: 85vh;
  position: relative;
  background: #fff;
  .export-image-loader {
    width: 30%;
    height: 100px;
    position: absolute;
    background: #fff;
    left: 35%;
    top: 0;
    box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    .loading:after {
      color: #0968b5;
      overflow: hidden;
      display: inline-block;
      vertical-align: bottom;
      -webkit-animation: ellipsis steps(4, end) 1s infinite;
      animation: ellipsis steps(4, end) 1s infinite;
      content: "...";
    }

    @keyframes ellipsis {
      0% {
        width: 0;
      }
      100% {
        width: 20px;
      }
    }

    @-webkit-keyframes ellipsis {
      0% {
        width: 0;
      }
      100% {
        width: 30px;
      }
    }
  }
  .headder-container {
    width: 90%;
    margin: auto;
    &.exporting {
      opacity: 0.5;
    }
    .headder-options-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 2rem 0;
    }
    .headder-teams-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .option-content {
        width: 40%;
      }
    }
    .option-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      width: 33%;
      label {
        color: #6f7a80;
        font-weight: 700;
      }
      select {
        margin: 1rem 0;
        border: 1px solid #ccc;
        width: 70%;
        color: #333;
        font-size: 1em;
        height: 36px;
        -webkit-appearance: none;
        border-radius: 1.5rem;
      }
    }
  }
  .data-container {
    width: 90%;
    margin: 2rem auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    .probability-container {
      width: 100%;
      .probability-graph {
        height: 10px;
        background: gray;
      }
    }
    .container-flex {
      width: 100%;
      padding: 1rem;
      margin-top: 2rem;
      align-self: stretch;
      &.team-container {
        width: 40%;
        display: inline;
        float: left;
        a {
          text-decoration: none;
          color: #000;
        }
      }
    }
    .stats-box {
      table {
        width: 100%;
        height: 100%;
        tr {
          td {
            text-align: center;
            &:first-child {
              text-align: left;
            }
          }
          th:first-child {
            text-align: left;
          }
        }
      }
    }
    .hidden-logo {
      display: none;
    }
    &.to-print {
      padding: 3rem;
      .no-print {
        display: none;
      }
      .hidden-logo {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        margin-bottom: 2rem;
        .navbarLogo {
          width: 10%;
          height: 10%;
          min-height: 30px;
          min-width: 30px;
        }
        h1 {
          width: 70%;
          font-family: "Roboto", sans-serif;
          margin-left: 1rem;
        }
      }
    }
    .no-print {
      width: 100%;
    }
  }
  #print-buttons-options {
    width: fit-content;
    margin-top: 1rem;
    display: none;
    margin: 5px 0 0 5%;
    text-align: left;
    border: 1px solid #ed4242;
    border-radius: 24px;
    padding: 1rem;
    color: #000;
    background: #fff;
    visibility: hidden;
    opacity: 0;
    align-items: center;
    justify-content: center;
    transition: visibility 200ms, opacity 200ms, display 200ms;
    &.active {
      display: flex;
      visibility: visible;
      opacity: 1;
      transition: visibility 200ms, opacity 200ms, display 200ms;
    }
  }
  .full-width-m {
    width: 90vw;
  }
  .personilized-dashboard {
    background: #fff;
    position: relative;
    padding-bottom: 5rem;
    margin-bottom: 5rem;
    overflow: scroll;
    touch-action: manipulation;

    .cover {
      width: 100%;
      height: 1000px;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      display: none;
      break-after: page;
      .cover-header {
        text-align: center;
      }
      .base-team-info {
        width: 40%;
        margin: 1rem auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        img {
          width: 150px;
          margin-right: 2rem;
        }
      }
      .rival-team-info {
        width: 65%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        img {
          width: 100px;
          margin-right: 2rem;
        }
      }
    }
    .dashboard-content-container {
      position: relative;
      .boxshadow {
        box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
      }
      [id^="statisticsTable"] table {
        width: 100%;
        height: 100%;
        text-align: center;
        tr {
          width: 100%;
          td {
            text-align: center;
            &:first-child {
              text-align: left;
            }
          }
          th:first-child {
            text-align: left;
          }
        }
      }
      [id^="Featured"] table,
      [id^="Table"] table {
        width: 100%;
        height: 100%;
      }
      [id^="Title"],
      [id^="Title"] h1,
      [id^="Link"] {
        white-space: pre-wrap;
      }
      .shooting-radar-chart-box {
        height: 100%;
        select {
          height: 10%;
        }
        canvas {
          height: 90% !important;
        }
      }
      .hidden-logo {
        display: none;
      }

      &.to-print {
        [id^="Featured"],
        [id^="TeamPerformance"],
        [id^="BasicTeamStats"],
        [id^="AdvancedTeamStats"],
        [id^="ComparisonBarChart"],
        [id^="Title"],
        [id^="Note"],
        [id^="statisticsTable"] {
          border: 1px solid black;
        }
      }
    }

    @media print {
      .personilized-dashboard {
        .rival-team-info {
          background: ${(props) => (props.color ? props.color : "black")};
        }
      }
    }
  }
  .no-data-messagge {
    box-shadow: 0 0 10px rgb(0 0 0 / 0.2);
    width: 90%;
    margin: 2rem auto;
    padding: 1rem;
    border-radius: 24px;
  }

  @media (min-width: 867px) {
    .data-container .container-flex {
      width: 46%;
    }
    .data-container .no-print {
      width: auto;
    }
    .data-container &.to-print {
      .hidden-logo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 15%;
        .navbarLogo {
          width: 25%;
          height: 25%;
          min-height: 30px;
          min-width: 30px;
        }
        h1 {
          width: 70%;
          font-family: "Roboto", sans-serif;
        }
      }
    }
    .full-width-m {
      width: auto;
    }
  }
`;

export const SharePopup = styled.div`
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  background: #000000b3;
  z-index: 50;
  transition: visibility 500ms, opacity 500ms, display 500ms;
  &.hide {
    opacity: 0;
    visibility: hidden;
  }

  &.show {
    opacity: 1;
    visibility: visible;
    transform: scale(1);
  }

  .popup {
    width: 50vw;
    height: 50vh;
    background: #fff;
    margin: 25vh 25vw;
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    .bold {
      font-weight: 700;
    }
    .closePopup {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }
`;
